import { TOptions } from "i18next";
import { ModalProps, useModal } from "melco-ui";
import { ReactNode, useCallback } from "react";
import { useTranslation } from "react-i18next";

type UseConfirmOptions = Pick<ModalProps, "getContainer"> & {
  translationPrefix: string;
  translationOptions?: TOptions;
  content?: ReactNode;
};

const translationKeys = (prefix: string, key: string) => {
  return [
    [prefix, "confirmation", key].join("."),
    ["global", "confirmation", key].join("."),
  ];
};

export const useConfirm = (
  onOk: () => Promise<void>,
  {
    translationPrefix,
    translationOptions,
    content,
    getContainer,
  }: UseConfirmOptions
) => {
  const { t } = useTranslation();

  const modal = useModal();

  return useCallback(() => {
    modal.confirm({
      title: t(
        translationKeys(translationPrefix, "title") as any,
        translationOptions ?? {}
      ),
      content: content
        ? content
        : t(
            translationKeys(translationPrefix, "message") as any,
            translationOptions ?? {}
          ),
      okText: t(
        translationKeys(translationPrefix, "ok") as any,
        translationOptions ?? {}
      ),
      cancelText: t(
        translationKeys(translationPrefix, "cancel") as any,
        translationOptions ?? {}
      ),
      onOk,
      getContainer,
    });
  }, [t, onOk, getContainer, content, translationPrefix, translationOptions]);
};
